import { useDispatch } from "react-redux";
import { hide_Options } from "../features/Customeselect";
import { useEffect, useRef, useState } from "react";

// Shared searchable dropdown (used by many screens - every existing prop keeps its behaviour).
// Changes:
//  - keyboard focus moves inside THIS dropdown only (the old global jQuery selector ".option-list [tabindex=0]"
//    could jump into another list on the page, e.g. the report grid or another open popup)
//  - type-ahead: typing a letter / digit on the closed box opens it with that text already searched
//  - Alt+ArrowDown or F4 opens, Escape closes and returns focus to the box (standard combobox keys)
//  - the typed search is kept when the parent re-renders (it used to reset the list while text stayed)
//  - optional props.searchKeys = ["code", "alias"]: extra fields searched besides displayName
// props.keydown (screen tab-order navigation) still runs first; if it handles the key, nothing else happens.
// any single printable character (plain ES2015: no Unicode property escapes, the project avoids newer syntax)
const Is_TypeAheadKey = (e) =>
  Boolean(e.key) && e.key.length === 1 && e.key.trim() !== "" && !e.ctrlKey && !e.metaKey && !e.altKey;

function CustomizedSelectoption(props) {
  const dispatch = useDispatch();

  const [arrOption, setarrOption] = useState([]);
  const [strSearch, setstrSearch] = useState("");
  const [strdefaultval, setstrdefaultval] = useState("");
  const containerRef = useRef(null);
  const InputRef = useRef(null);
  const SearchRef = useRef("");

  // local filter (server search through props.onChange returns an already filtered list)
  const Filter_Options = (arrData, strVal) => {
    if (!Array.isArray(arrData)) return [];
    const strFind = String(strVal || "").toLowerCase();
    if (props.onChange !== undefined || !strFind) return arrData;
    const arrKeys = [props.displayName].concat(Array.isArray(props.searchKeys) ? props.searchKeys : []);
    return arrData.filter((dt) =>
      arrKeys.some((k) => String(dt[k] === null || dt[k] === undefined ? "" : dt[k]).toLowerCase().includes(strFind))
    );
  };

  useEffect(() => {
    if (props.arrydata !== undefined) {
      let defaultval = props.arrydata.filter(
        (dt) =>
          props.defaultval !== undefined &&
          props.defaultval !== null &&
          props.defaultval !== "" &&
          String(dt[props.disvalue]) === String(props.defaultval)
      );

      if (defaultval.length > 0 && props.replace === undefined) {
        setstrdefaultval(defaultval[0][props.displayName] || "");
      } else if (defaultval.length > 0 && props.replace !== undefined) {
        setstrdefaultval(
          ((defaultval[0][props.displayName] || "") + "").replace(
            props.replace[0],
            props.replace[1]
          )
        );
      } else {
        setstrdefaultval("");
      }
    } else {
      setstrdefaultval("");
    }

    if (props.arrydata !== undefined) {
      setarrOption(Filter_Options(props.arrydata, SearchRef.current));
    }
  }, [props]);

  // Close the dropdown when the user clicks anywhere outside this component.
  useEffect(() => {
    if (!props.showoption) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        dispatch(hide_Options({ [props.optionparem]: false }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props.showoption, props.optionparem, dispatch]);

  const Set_Search = (val) => {
    SearchRef.current = val || "";
    setstrSearch(val || "");
  };
  const input_Onchange = (val) => {
    if (props.onChange !== undefined) {
      Set_Search(val);
      props.onChange(val);
    } else if (props.arrydata !== undefined) {
      Set_Search(val);
      setarrOption(Filter_Options(props.arrydata, val));
    } else {
      Set_Search(val);
    }
  };
  const Open_List = (strSeed) => {
    if (props.disabled) return;
    if (!props.showoption) dispatch(hide_Options({ [props.optionparem]: true }));
    input_Onchange(strSeed || "");
  };
  const Close_List = () => {
    dispatch(hide_Options({ [props.optionparem]: false }));
    if (InputRef.current) InputRef.current.focus();
  };
  const Focus_Option = (iIndex) => {
    const objEl = containerRef.current && containerRef.current.querySelector(`.option-list [tabindex="${iIndex}"]`);
    if (objEl) objEl.focus();
  };

  const Select_Value = (item) => {
    dispatch(
      hide_Options({
        [props.optionparem]: !props.showoption,
      })
    );

    const displayVal = (item[props.displayName] || "").toString();

    if (props.valueonly) {
      Set_Search(displayVal);
      props.select_value(item[props.disvalue]);
    } else {
      Set_Search(displayVal);
      props.select_value(item);
    }
  };

  return (
    <div className="custom-select" ref={containerRef}>
      <input
        ref={InputRef}
        className="form-control"
        disabled={props.disabled ? true : false}
        type="text"
        placeholder={props.placeholder}
        value={strdefaultval}
        readOnly
        role="combobox"
        aria-expanded={Boolean(props.showoption)}
        aria-label={props.placeholder}
        onClick={() => {
          dispatch(
            hide_Options({ [props.optionparem]: !props.showoption })
          );
          input_Onchange("");
        }}
        onKeyDown={(e) => {
          if (props.keydown) props.keydown(e);
          if (e.defaultPrevented || props.disabled) return;
          if ((e.altKey && e.key === "ArrowDown") || e.key === "F4") {
            e.preventDefault();
            Open_List("");
          } else if (e.key === "Escape" && props.showoption) {
            e.preventDefault();
            Close_List();
          } else if (Is_TypeAheadKey(e)) {
            e.preventDefault();
            Open_List(e.key); // type-ahead: the typed character becomes the search text
          }
        }}
        tabIndex={props.taborder}
      />

      <i className="fa-solid fa-caret-down"></i>

      {props.showoption && (
        <div className="custom-option">
          <div className="search-option">
            <input
              type="text"
              placeholder={"Search " + props.EmptVal}
              value={strSearch}
              onChange={(e) => input_Onchange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "ArrowDown") {
                  e.preventDefault();
                  Focus_Option(0);
                } else if (e.key === "Enter" && arrOption.length > 0) {
                  e.preventDefault();
                  Select_Value(arrOption[0]);
                } else if (e.key === "Escape") {
                  e.preventDefault();
                  Close_List();
                }
              }}
              autoFocus
            />

            {arrOption.length === 0 && <span>No Records Found</span>}
          </div>

          <div className="option-list" role="listbox">
            {arrOption.map((item, Index) => {
              const displayText = (item[props.displayName] || "").toString();

              return (
                <button
                  key={Index}
                  tabIndex={Index}
                  role="option"
                  onClick={() => Select_Value(item)}
                  onKeyDown={(e) => {
                    let arrlength = arrOption.length - 1;

                    if (e.key === "ArrowDown") {
                      e.preventDefault();
                      Focus_Option(arrlength === Index ? 0 : Index + 1);
                    }

                    if (e.key === "ArrowUp") {
                      e.preventDefault();
                      Focus_Option(Index === 0 ? arrlength : Index - 1);
                    }

                    if (e.key === "Enter") {
                      e.preventDefault();
                      Select_Value(item);
                    }
                    if (e.key === "Escape") {
                      e.preventDefault();
                      Close_List();
                    }
                  }}
                >
                  {props.replace !== undefined
                    ? displayText.replace(
                      props.replace[0],
                      props.replace[1]
                    )
                    : displayText}

                  <br />

                  {props.onChange !== undefined && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {props.displayName1 !== undefined && (
                        <label>
                          {props.displayName1} :{" "}
                          {item[props.disvalue1] ?? ""}
                        </label>
                      )}

                      {props.displayName2 !== undefined && (
                        <label>
                          {props.displayName2} :{" "}
                          {item[props.disvalue2] ?? ""}
                        </label>
                      )}
                    </div>
                  )}
                </button>
              );
            })}
          </div>

          {props.btnshow && (
            <div className="popup-footer">
              <div className="popup-btn-group">
                <button
                  className="btn-fabgreen"
                  onClick={(e) => {
                    dispatch(
                      hide_Options({
                        [props.optionparem]: !props.showoption,
                      })
                    );
                    props.show_popup(e);
                  }}
                >
                  <i className="fa-solid fa-circle-plus"></i>
                  Create {props.btnname}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CustomizedSelectoption;